import React from 'react';
import { CreateAccountForm, Disclaimer } from '@surfline/quiver-react';

import { useCreateAccount } from './useCreateAccount';

/**
 * @function CreateAccount
 * @return {JSX.Element}
 */
const CreateAccount = () => {
  const { createAccount, loading, error } = useCreateAccount();

  return (
    <div className="sl-meter-create-account">
      <CreateAccountForm
        onSubmit={createAccount}
        loading={loading}
        error={error}
        receivePromotionsLabel="I would like to receive product updates and promotional offers from Surfline and its partners"
      />
      <Disclaimer referenceText="Create Account" hideTrialText />
    </div>
  );
};
export default CreateAccount;
